import React, { useEffect, useState } from "react";
import { InView } from 'react-intersection-observer';
import Slider from 'react-slick';
import LazyLoad from 'react-lazyload';

export default function IndustryRetailUseCase(props) {
    const _isMounted = false;
  const [isMobile, setisMobile] = useState(false);
  
  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 1023);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  }); 
  
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          centerPadding: '20px',
          autoplay: true,
          infinite: true,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          centerPadding: '20px',
          autoplay: true,
          infinite: true,
        }
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          centerPadding: '20px',
          autoplay: true,
          infinite: true,
        }
      }
    ]
  };

  const { title, header, content, classes, useCaseItems } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  return (
    <InView onChange={(inView) => setIsVisible(inView)} >
      <div className={`page-intro-section section-gap ${classes}`} id={props.id ? props.id : ''}>
        <div className="container">
            <div className="section-gap-small reatail-usecase-title">
                <h2 className="h2">{header}</h2>
                {content}
            </div>
            <div className="usecase-grid d-flex flex-wrap">
                {isMobile && <> <Slider {...settings}>
                    {useCaseItems && useCaseItems.map((item, i) => {
                        return (
                            <div className="usecase-item" key={i}>
                                <div className="usecase-image">
                                    <LazyLoad><img src={item.image} title={item.imagetitle} alt={item.imagealt} /></LazyLoad>
                                </div>
                                <div className="usecase-content">
                                    <h4 className="h4">{item.title}</h4>
                                    <div className="hover-content">
                                        <h4 className="h4">{item.title}</h4>
                                        <p>{item.content}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </Slider></>}
                {!isMobile && <>
                    {useCaseItems && useCaseItems.map((item, i) => {
                        return (
                            <div className="usecase-item" key={i}>
                                <div className="usecase-image">
                                  <LazyLoad><img src={item.image} title={item.imagetitle} alt={item.imagealt} /></LazyLoad>
                                </div>
                                <div className="usecase-content">
                                    <h4 className="h4">{item.title}</h4>
                                    <div className="hover-content">
                                        <h4 className="h4">{item.title}</h4>
                                        <p>{item.content}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </>}
            </div>
        </div>
      </div>
    </InView>
  );
}

